module.exports = __webpack_public_path__ + "img/city@2x.dfa89da.webp";